<div class="multi-cart" (window:resize)="onResize($event)" [attr.data-test]="'feature-shopCart'">
  <h3 class="page-title" [attr.data-test]="'title-pageTitle'">{{ 'multi-cart.title' | translate }}</h3>
  <app-access-control [notForViewer]="true" [description]="true">
    <div class="multi-cart__content" ngProjectAs="[slot][nonViewerContent]">
      @if ((currentCartLoaded$ | async) === false && currentCartLoaded) {
        @if (!isContractInCart()) {
          <app-current-cart
            #currentCartRef
            [isUsStore]="isUsStore"
            [isCaStore]="isCaStore"
            [rfqActive]="rfqActive"
            [isRfqOnly]="isRfqOnly"
            [minimumOrderValue]="minimumOrderValue"
            [isExportCartActive]="isExportCartActive"
            [loadingCart]="switchingCartInProgress
              || (isCartOperationInProgress && cartIdOfCartWhichIsPrepareToDelete === currentCart.id)"
            [currency]="currency"
            [currentCart]="currentCart"
            [currentCartItems]="currentCartItems ?? []"
            [hasNickname]="hasNickname"
            [wishlists]="wishlists"
            [isWishlistsActive]="isWishlistsActive"
            [isProductTagsActive]="isProductTagsActive"
            [addWishlistModalActive]="addWishlistModalActive"
            [isPredefinedEquipmentFlowEnabled]="(isPredefinedEquipmentFlowEnabled$ | async) ?? false"
            (showAddWishlistModal)="addWishlistModalActive = $event"
            (showAddNicknameModal)="addNicknameModalActive = $event"
            (showDeleteCartModal)="deleteCurrentCart($event)"
            (generatePdfFile)="generatePdfFile()"
            (removeCartItem)="removeCartItem($event)"
            (updateCartItemQuantity)="updateCartItemQuantity($event)">
          </app-current-cart>
        }
        @if (isContractInCart()) {
          <app-current-quote
            [loadingQuote]="switchingCartInProgress
              || (isCartOperationInProgress && quoteIdOfQuoteWhichIsPrepareToDelete === currentCart.id)"
            [currency]="currency"
            [totals]="totals"
            [currentCart]="currentCart"
            [currentCartItems]="currentCartItems"
            [hasNickname]="hasNickname"
            [validUntilDate]="validUntilDate"
            (showAddNicknameModal)="addNicknameModalActive = $event"
            (showDeleteQuoteModal)="deleteCurrentQuote($event)"
            (removeQuoteItem)="quoteItemToDelete = $event"
            (showRemoveConfigurationModal)="removeConfigurationModalActive = $event">
          </app-current-quote>
        }
        <div class="multi-cart__other-carts">
          @if (currentTab === multiCartTabs.PARTS) {
            <h6>{{ 'multi-cart.other-carts' | translate }}</h6>
          }
          @if (currentTab === multiCartTabs.SERVICES) {
            <h6>{{ 'multi-cart.other-quotes' | translate }}</h6>
          }
          <div class="tabs">
            @if (otherCarts?.length > 0) {
              <div class="tabs__list margin-left-0">
                @if (otherPartProductCarts?.length > 0) {
                  <span
                    class="tabs__item" [ngClass]="{'is-active': currentTab === multiCartTabs.PARTS}"
                    (click)="currentTab = multiCartTabs.PARTS">
                    {{ 'multi-cart.tab-parts' | translate }}
                    <span>({{ otherPartProductCarts?.length }})</span>
                  </span>
                }
                @if (otherServiceProductCarts?.length > 0) {
                  <span
                    class="tabs__item" [ngClass]="{'is-active': currentTab === multiCartTabs.SERVICES}"
                    (click)="currentTab = multiCartTabs.SERVICES">
                    {{ 'multi-cart.tab-services' | translate }}
                    <span>({{ otherServiceProductCarts?.length }})</span>
                  </span>
                }
              </div>
            }
            <div class="tabs__panel" [ngClass]="{'is-active': currentTab === multiCartTabs.PARTS}">
              <div class="other-carts" (window:resize)="onResize($event)">
                <div class="create-new-cart" (click)="createNewEmptyCartAndRedirectTo()" [attr.data-test]="'button-createNewCart'">
                  <h6>+ {{ 'multi-cart.create-new-cart' | translate }} </h6>
                </div>
                @for (otherCart of otherPartProductCarts |
                  slice:0:(viewAllPartsCarts ? otherPartProductCarts.length : viewItemsForParts); track otherCart) {
                  <app-other-cart
                      [loadingCart]="(switchingCartInProgress && cartIdOfSwitchingCart === otherCart.id)
                      || (isCartOperationInProgress && cartIdOfCartWhichIsPrepareToDelete === otherCart.id)"
                    [cart]="otherCart"
                    [cartImages]="otherCartsImages"
                    (switchCartEmit)="switchDefaultCart($event)"
                    (deleteCartEmit)="deleteOtherCart($event)">
                  </app-other-cart>
                }
              </div>
              <div class="action-buttons">
                @if (otherPartProductCarts?.length > viewItemsForParts && !viewAllPartsCarts) {
                  <button
                    type="button" class="button button--link icon-arrow-long-right"
                    (click)="viewAllPartsCarts = true">
                    {{ 'multi-cart.button-view-all' | translate }}
                  </button>
                }
                @if (otherPartProductCarts?.length > viewItemsForParts && viewAllPartsCarts) {
                  <button
                    type="button" class="button button--link icon-arrow-long-left"
                    (click)="viewAllPartsCarts = false">
                    {{ 'multi-cart.button-show-less' | translate }}
                  </button>
                }
              </div>
            </div>
            <div class="tabs__panel" [ngClass]="{'is-active': currentTab === multiCartTabs.SERVICES}">
              <div class="other-quotes" (window:resize)="onResize($event)">
                @for (otherQuote of otherServiceProductCarts |
                  slice:0:(viewAllServicesQuotes ? otherServiceProductCarts.length : viewItemsForServices); track otherQuote) {
                  <app-other-quote
                      [loadingQuote]="(switchingCartInProgress && cartIdOfSwitchingCart === otherQuote.id)
                      || (isCartOperationInProgress && quoteIdOfQuoteWhichIsPrepareToDelete === otherQuote.id)"
                    [currency]="currency"
                    [quote]="otherQuote"
                    [quoteImages]="otherCartsImages"
                    (switchCartEmit)="switchDefaultCart($event)"
                    (deleteQuoteEmit)="deleteOtherQuote($event)">
                  </app-other-quote>
                }
              </div>
              <div class="action-buttons">
                @if (otherServiceProductCarts?.length > viewItemsForServices && !viewAllServicesQuotes) {
                  <button
                    type="button" class="button button--link icon-arrow-long-right"
                    (click)="viewAllServicesQuotes = true">
                    {{ 'multi-cart.button-view-all' | translate }}
                  </button>
                }
                @if (otherServiceProductCarts?.length > viewItemsForServices && viewAllServicesQuotes) {
                  <button
                    type="button" class="button button--link icon-arrow-long-left"
                    (click)="viewAllServicesQuotes = false">
                    {{ 'multi-cart.button-show-less' | translate }}
                  </button>
                }
              </div>
            </div>
          </div>
        </div>
      } @else {
        <div class="multi-cart__current-cart-loader">
          <div class="loading-animation"></div>
        </div>
      }
    </div>
  </app-access-control>
  @if (currentCart) {
    <app-modal-add-cart-name
      [cartId]="currentCart.id"
      [hasNickname]="hasNickname"
      [newNameChange]="currentCartName$"
      [showAddNicknameModal]="addNicknameModalActive"
      [isContractInCart]="isContractInCart()"
      (closeModal)="addNicknameModalActive = false">
    </app-modal-add-cart-name>
  }
  <app-add-new-wishlist
    [showModal]="addWishlistModalActive"
    (closeModal)="addWishlistModalActive = false">
  </app-add-new-wishlist>
  <app-modal-confirm
    [type]="iconType.WARNING"
    [modalTitle]="'multi-cart.delete-cart-title' | translate"
    [notifyText]="'multi-cart.delete-cart-text' | translate"
    [cancelBtnText]="'multi-cart.cancel-btn' | translate"
    [primaryBtnText]="'multi-cart.delete-btn' | translate"
    [showModalConfirm]="deleteCartModalActive"
    [modalName]="'cart'"
    (closeModalConfirm)="deleteCartModalActive = false"
    (primaryActionConfirm)="deleteCart()">
  </app-modal-confirm>
  <app-modal-confirm
    [type]="iconType.WARNING"
    [modalTitle]="'multi-cart.delete-quote-title' | translate"
    [notifyText]="'multi-cart.delete-quote-text' | translate"
    [cancelBtnText]="'multi-cart.cancel-btn' | translate"
    [primaryBtnText]="'multi-cart.delete-btn' | translate"
    [showModalConfirm]="deleteQuoteModalActive"
    [modalName]="'quote'"
    (closeModalConfirm)="deleteQuoteModalActive = false"
    (primaryActionConfirm)="deleteQuote()">
  </app-modal-confirm>
  <app-modal-confirm
    [type]="iconType.WARNING"
    [modalTitle]="'multi-cart.remove-configuration-title' | translate"
    [notifyText]="'multi-cart.remove-configuration-text' | translate"
    [cancelBtnText]="'multi-cart.cancel-btn' | translate"
    [primaryBtnText]="'multi-cart.remove-btn' | translate"
    [showModalConfirm]="removeConfigurationModalActive"
    [modalName]="'configuration'"
    (closeModalConfirm)="removeConfigurationModalActive = false"
    (primaryActionConfirm)="removeQuoteItem()">
  </app-modal-confirm>
</div>
